import { BaseEntity } from "yt-ng-framework";

export class Proizvodjac extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string = null;
    TataID: number = null;
    Items: Proizvodjac[] = null;
    SourceID: number = null;
    GlavniDobavljacID: number = null;
    SourceValues: string = null;
    
    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.TataID = input.TataID;
        this.SourceID = input.SourceID;
        this.GlavniDobavljacID = input.GlavniDobavljacID;
        if (input.Items!=null){
            this.Items=[];
            input.Items.forEach(Item => {
                return this.Items.push(new Proizvodjac().Deserialize(Item))
            });
        }

        return this;
    }



    Serialize(input:Proizvodjac){
        input.Items = null;
        return input;
    }
}